import { z } from "zod";
export const twinQueryInterfaceSchema = z.enum(["api", "cli", "mcp"]);
